import React from "react";

const ViewMoreImages = ({ onClick, customClass }) => {
  return (
    <div className={`ViewMoreImages ${customClass}`} onClick={onClick}>
      <span className="ViewMoreImages_text">View more images</span>
      <img className="ViewMoreImages_image" src="/assets/img/view-more-images.svg" alt="View more images" />
    </div>
  );
};

export default ViewMoreImages;
